import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';
import AddPermission from './sections/add';
import EditPermission from './sections/edit';


const Permissions = () => {
    const [permissions, setPermissions] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [perId, setPerId] = useState(null);
    const [filterText, setFilterText] = useState('');
    
    const fetchPermissions = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/permissions?page=${currentPage + 1}`)
            .then(response => {
                setPermissions(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching the permissions!", error);
                setPermissions([]);
            });
    };

    useEffect(() => {
        fetchPermissions(currentPage);
    }, [currentPage]);
    
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    // Search input handler
    const filteredItems = permissions.filter(
        item => item.name.toLowerCase().includes(filterText.toLowerCase())
    );


    return(
        <>
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Permissions</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Permissions</li>
                            </ul>
                        </div>
                        <div className="col-auto float-end ms-auto">
                            <Link to="#" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_permission">
                                <i className="fa-solid fa-plus"></i> Add Permission</Link>
                        </div>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-4">
                        <input className="form-control" type="text"
                            placeholder="Search permission..." aria-label="Search Input"
                            value={filterText} onChange={(event)=>{
                                setFilterText(event.target.value)
                            }} />
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Permission Name</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.map((row) => (
                                                        <tr key={row.id}>
                                                            <td>{row.name}</td>
                                                            <td className="text-end">
                                                                {!(row.name.toLowerCase().includes("admin")) &&
                                                                    <div className="dropdown dropdown-action">
                                                                        <Link to="#" className="action-icon dropdown-toggle"
                                                                            data-bs-toggle="dropdown" aria-expanded="false"
                                                                                onClick={() => setPerId(`${row.id}`)}>
                                                                                <i className="material-icons">more_vert</i></Link>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                                data-bs-target={`#edit_permission_${row.id}`}>
                                                                                    <i className="fa-solid fa-pencil m-r-5"></i> Edit</Link>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="2">No records found</td>
                                                    </tr>
                                                ) 
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
            </div>

            <AddPermission list={fetchPermissions}/>
            <EditPermission list={fetchPermissions} permId={perId} />
        </>
    );
}

export default Permissions